import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=2ad20a16"
import script from "@/controllers/ap/user/Edit?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/user/Edit?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports